/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Trips_RemoveInputs */

const en_ui_trips_remove = /** @type {(inputs: Ui_Trips_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove from trip`)
};

const de_ui_trips_remove = /** @type {(inputs: Ui_Trips_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aus Tour entfernen`)
};

/**
* | output |
* | --- |
* | "Remove from trip" |
*
* @param {Ui_Trips_RemoveInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_trips_remove = /** @type {((inputs?: Ui_Trips_RemoveInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Trips_RemoveInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_trips_remove(inputs)
	return de_ui_trips_remove(inputs)
});